export default __webpack_public_path__ + "static/media/Digital-Organization.6a7f6ff4.pdf";